import React from "react";
import "./NotFound.css";

const Oops = () => (
  <div className="NotFound-header">
    <header className="NotFound-headerText">404 Not Found</header>
    <h3 className="NotFound-headersubText">
      Oops! The requested page "{window.location.pathname}" could not be found.
    </h3>
  </div>
);

export default Oops;
